module.exports = __webpack_public_path__ + "img/eleiko-strengthwear-back.1a491d06.jpg";